<template>
    <div>
        <div class="mainWrapper">
            <MainSideBarVue />

            <div class="rightContentWrapper">
                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">

                    <div class="theHeaderWrapper">

                        <div>

                            <i @click="$router.go(-1)"
                                style="font-size: 25px; font-weight: bold; cursor: pointer; margin-right: 10px;"
                                class="bi bi-arrow-left"></i>

                            {{ groupTalkStore.supervisorGroup.name }}


                        </div>

                        <button @click="groupTalkStore.openAddSupervisorsToAGroupModal" class="button-6" role="button">
                            + Add Supervisors To Group
                        </button>
                    </div>

                    <div class="searchBarWrapper">
                        <input v-model="searchQuery" type="text" class="form-control theBar"
                            placeholder="Search by name..." />
                    </div>

                    <div v-if="groupTalkStore.groupUsers.length > 0">

                        <div class="tableWrapper">

                            <table class="table table-hover my-custom-table">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Date added</th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr v-for="(groupUser, index) in filteredGroupUsers" :key="index">


                                        <td style=" width: 300px;">

                                            <div v-if="groupUser.user">

                                                {{ groupUser.user.name }}

                                            </div>

                                        </td>

                                        <td style=" width: 300px;">

                                            {{ groupTalkStore.formatDate(groupUser.created_at) }}


                                        </td>

                                        <td style="width: 150px;">

                                            <div class="iconsRow">




                                                <i @click="groupTalkStore.openDeleteGroupSupervisorUserModal(groupUser)" class="bi bi-trash theActionIcon"></i>






                                            </div>

                                        </td>
                                    </tr>

                                </tbody>




                            </table>




                        </div>

                    </div>

                    <div class="noTeamBox" v-else>

                        No supervisors added yet.

                    </div>



                </div>
            </div>
        </div>


        <div v-if="groupTalkStore.showAddSupervisorsToAGroupModal" class="modal-overlay">

            <div class="modal-box" style="width: 700px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Select Supervisors</b>
                    </div>

                    <div>
                        <i @click="groupTalkStore.closeAddSupervisorsToGroupModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-search-box" style="padding: 12px;">

                    <input v-model="groupListSearchQuery" type="text" class="form-control titleInput"
                        placeholder="Search..." />

                </div>

                <div class="modal-content">


                    <!-- {{ groupTalkStore.supervisorsToAddToAGroup }} -->


                    <div class="innerBox">


                        <div v-if="groupTalkStore.usersNotInThisGroup.length > 0">

                            <div class="talkItem" v-for="(user, index) in filteredSupervisotUsers" :key="index"
                                @click="groupTalkStore.addThisUserToAGroup(user)">



                                <div class="talkLeft">

                                    <div class="talkTitle">


                                        {{ user.name }}


                                    </div>




                                </div>

                                <div class="talkRight">


                                    <div v-if="user.is_checked" class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault" checked>
                                    </div>

                                    <div v-else class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault">
                                    </div>



                                </div>




                            </div>

                        </div>

                        <div v-else>

                            You have already added all your supervisors to this group.

                        </div>








                    </div>

                    <div v-if="groupTalkStore.usersNotInThisGroup.length > 0" class="groupActionBox"
                        style="margin-top: 30px;">


                        <button @click="groupTalkStore.closeAddSupervisorsToGroupModal"
                            class="btn btn-light">Cancel</button>

                        <button v-if="groupTalkStore.isLoading" class="btn btn-dark"><b>Updating</b></button>
                        <button v-else @click="groupTalkStore.addTheseSupervisorsToAGroup"
                            class="btn btn-dark"><b>Add</b></button>


                    </div>





                </div>
            </div>
        </div>



        <div v-if="groupTalkStore.showDeleteGroupSupervisorUserModal" class="modal-overlay">

            <div class="modal-box" style="width: 500px">

                <div class="model-box-header">

                    <div style="font-size: 17px" v-if="groupTalkStore.currentSupervisorGroupUser.user">
                        <b>Removing {{ groupTalkStore.currentSupervisorGroupUser.user.name }}?</b>
                    </div>

                    <div>
                        <i @click="groupTalkStore.closeDeleteGroupSupervisorUserModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>



                <div class="modal-content">


                    <div style="font-size: 16px; text-align: left;">
                        Are you sure you want to remove this supervisor from this group?
                    </div>


                    <div class="groupActionBox" style="margin-top: 30px;">


                        <button @click="groupTalkStore.closeDeleteGroupSupervisorUserModal"
                            class="btn btn-light">Cancel</button>

                        <!-- <button v-if="templateStore.isLoading" class="btn btn-dark"><b>Updating</b></button> -->
                        <button @click="groupTalkStore.removeThisSupevisorFromGroup"
                            class="btn btn-dark"><b>Save</b></button>


                    </div>





                </div>
            </div>
        </div>


    </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { useGroupTalkStore } from "@/stores/GroupTalkStore";
import { onMounted, defineProps, ref, computed } from "vue";



const props = defineProps({
    uuid: String
})

const groupTalkStore = useGroupTalkStore();
const searchQuery = ref('')

const groupListSearchQuery = ref('')


const filteredSupervisotUsers = computed(() => {

    return groupTalkStore.usersNotInThisGroup
        .filter(user => user.name.toLowerCase().includes(groupListSearchQuery.value.toLowerCase()))

});

const filteredGroupUsers = computed(() => {
    return groupTalkStore.groupUsers.filter(groupUser =>
        groupUser?.user &&
        groupUser.user.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    ) || [];
});






onMounted(() => {


    groupTalkStore.fetchASupervisorGroup(props.uuid)


})





</script>

<style scoped>
.mainWrapper {
    /* background-color: aliceblue; */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    /* overflow-y: auto; */
    width: 83%;
    display: flex;
    flex-direction: column;
}

.contentContainer {
    /* overflow-y: auto; */
    background-color: rgb(208, 28, 55);
    /* margin: 30px; */
    margin-top: 100px;
}

.rightColumns {
    /* display: flex;
  flex-direction: column; */
}

.topNav {
    background-color: blue;
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    justify-content: space-between;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}

.theBar {
    width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.button-6 {
    align-items: center;
    /* background-color: #FFFFFF; */
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    display: inline-flex;
    font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 1.25;
    margin: 0;
    min-height: 3rem;
    padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
    position: relative;
    text-decoration: none;
    transition: all 250ms;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    width: auto;
}

.button-6:hover,
.button-6:focus {
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
    transform: translateY(-1px);
}

.button-6:active {
    background-color: #f0f0f1;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
    color: rgba(0, 0, 0, 0.65);
    transform: translateY(0);
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}

.campName {
    text-decoration: none;
    color: inherit;
}

.campName:hover {
    color: rgb(10, 159, 92);
    cursor: pointer;
    text-decoration: none;
}

.iconsRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.theActionIcon {
    font-weight: bolder;
    font-size: 18px;
    color: rgb(5, 2, 2);
    cursor: pointer;
}

.theActionIcon:hover {
    cursor: pointer;
    color: rgb(30, 158, 30);
    scale: 1.3;
    transition: 1s;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 999;
    /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
    background-color: white;
    width: 1100px;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    text-align: center;
}

.model-box-header {
    display: flex;
    justify-content: space-between;
    /* background-color: antiquewhite; */
    height: 40px;
    margin-bottom: 15px;
}

.form-control {
    background-color: rgb(243, 246, 246);
}

.createBTN {
    width: 100%;
    margin-top: 20px;
}

.noTeamBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
}

.noMatchBox {
    background-color: red;
    width: 100%;
}

.loadMoreBtn {
    background-color: black;
    border-radius: 10px;
}

.inviteInput {
    width: 500px;
    font-size: 13px;
    cursor: pointer;
}

.innerBox {
    /* background-color: red; */
    overflow-y: auto;
    width: 100%;
    height: 500px;
    padding: 12px;
}


.talkItem {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    margin-bottom: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
}

.talkItem:hover {
    background-color: rgb(249, 253, 252);
}

.talkLeft {
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 80%;
    /* background-color: #aadada; */
}

.talkRight {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    /* padding: 10px; */
    /* background-color: #3ddbdb; */
}

.talkTitle {
    /* background-color: #d9e7ff; */
    text-align: left;
    font-weight: bold;
    padding: 6px;
}


.groupActionBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
}
</style>